module.exports = __webpack_public_path__ + "images/emoji/tropical_fish.f3c6ca57833bc5927424.png";